import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import EventCard from '../ui/EventCard';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr'; // Assurez-vous d'importer la locale française

const EventsSection = () => {
  const navigate = useNavigate()
  const [load, setLoad] = React.useState(true);
  const [events, setEvents] = React.useState([]);

  useEffect(()=>{
    const query = new URLSearchParams({statut:'en cours' }).toString();

    fetch(process.env.REACT_APP_API_URL.concat('/public/events?'+ query), {method: 'GET'})
    .then((res) => {
      const token = res.headers.get('x-auth-token');
        if (token) localStorage.setItem('token', token);
        return res.json()
      })
    .then((data) => { 
      setEvents(data);
      setLoad(false);
    })
    .catch((err) => {
      console.error("Error fetching eglises:", err);
      setLoad(false);
    });
  }, [])

  return (
    <Grid container spacing={{xs:1.5, md: 3}} sx={{ mb: 6 }}>
      {events.map((event, index) => (
        <Grid size={{sx: 6, sm: 4, md:3}} minWidth={{ xs: 60, md: 300}} key={index}>
          <EventCard
            image={event.image}
            title={event.titre}
            dateFin={event.dateFin}
            description={'📍'+event.lieu+'\n'+moment.utc(event.date).format('ddd D MMM yyyy')+' à '+event.heure}
            onClick={() => navigate(`/billetterie/${event._id}`)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default EventsSection;